import React from 'react'

import { ScrollView, StyleSheet, Text } from 'react-native'

import { adaptive, colors } from '@sart/styles'

export default function FAQsItem(props) {
  const { route } = props
  const item = route.params?.item
  return (
    <ScrollView style={styles.wrapper}>
        <Text style={styles.text}>{item.content}</Text>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    paddingTop: 24,
    paddingBottom: 24,
    ...adaptive.wrapperPadding,
  },
  text: {
    paddingBottom: 38,
}
})
